import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { queryClient } from "@/queryClient";

import "./index.css";
import { Router } from "./Router";

Sentry.init({
  dsn: "https://a0bd6912d27e0b33c119b2427f6eba95@o4509278305517568.ingest.us.sentry.io/4509363448578048",
  sendDefaultPii: true,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "local",
});

const cognitoAuthConfig = {
  authority: import.meta.env.VITE_COGNITO_AUTHORITY_URL,
  client_id: import.meta.env.VITE_COGNITO_APP_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_APP_URL + "/login",
  response_type: "code",
  scope: "email openid profile",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <QueryClientProvider client={queryClient}>
        <Router />
        <Toaster />
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
);
